var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_29927",
    "data-name": "Group 29927",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96.001,
    viewBox: "0 0 96 96.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8108",
    "data-name": "Rectangle 8108",
    width: 50,
    height: 50,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26955",
    "data-name": "Group 26955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32574",
    "data-name": "Path 32574",
    d: "M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z",
    transform: "translate(8 8)",
    fill: "#4b74f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32574_-_Outline",
    "data-name": "Path 32574 - Outline",
    d: "M40,0A40,40,0,1,0,80,40,40,40,0,0,0,40,0m0-8A48,48,0,1,1-8,40,48.055,48.055,0,0,1,40-8Z",
    transform: "translate(8 8)",
    fill: "rgba(75,116,244,0.3)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Mail",
    transform: "translate(23 23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6648",
    "data-name": "Mask Group 6648",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35254",
    "data-name": "Path 35254",
    d: "M42.877,13.319c-1.823,1.416-4.232,3.223-12.533,9.253-1.652,1.2-4.606,3.9-7.511,3.874-2.889.016-5.786-2.62-7.5-3.874-8.3-6.03-10.718-7.829-12.541-9.245A.487.487,0,0,0,2,13.71V30.344A3.907,3.907,0,0,0,5.906,34.25H39.76a3.907,3.907,0,0,0,3.906-3.906V13.7A.49.49,0,0,0,42.877,13.319ZM22.833,23.833c1.888.033,4.606-2.376,5.973-3.369,10.8-7.837,11.621-8.52,14.111-10.474a1.947,1.947,0,0,0,.749-1.538V6.906A3.907,3.907,0,0,0,39.76,3H5.906A3.907,3.907,0,0,0,2,6.906V8.452a1.959,1.959,0,0,0,.749,1.538c2.49,1.945,3.312,2.637,14.111,10.474C18.227,21.457,20.945,23.866,22.833,23.833Z",
    transform: "translate(2.167 7.417)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.d1e8433e822aff4ff8047cd7a6dec3e9.svg";
export { ForwardRef as ReactComponent };